import { lazy } from 'react';

import IRoute from 'Shared/Routes/Models/IRoute';

import { MasooliatMadaniPaths } from './MasooliatMadaniPaths';

const BimehNamehMadaniDetailPage = lazy(() => import('../../Detail/Pages/BimehNamehMadaniDetailPage'));
const ElhaghiyehHayeSaderehMasooliatMadaniPage = lazy(
  () => import('../../ElhaghiyehHayeSadereh/Pages/ElhaghiyehHayeSaderehAtashsooziPage')
);
const ElhaghiyehSaderehDetailPage = lazy(
  () => import('../../ElhaghiyehSaderehDetail/Pages/ElhaghiyehSaderehDetailPage')
);
const MasooliatMadaniEstelamPage = lazy(() => import('../../Estelam/Pages/MasooliatMadaniEstelamPage'));

const MasooliatMadaniRoutes: IRoute[][] = [
  [
    {
      path: MasooliatMadaniPaths.BimehNameh.Estelam,
      component: MasooliatMadaniEstelamPage,
      needAuth: false,
    },
    {
      path: MasooliatMadaniPaths.BimehNameh.Detail,
      component: BimehNamehMadaniDetailPage,
      needAuth: true,
    },
    {
      path: MasooliatMadaniPaths.BimehNameh.ElhaghiyehHayeSadereh,
      component: ElhaghiyehHayeSaderehMasooliatMadaniPage,
      needAuth: true,
    },
    {
      path: MasooliatMadaniPaths.BimehNameh.ElhaghiyehSaderehDetail,
      component: ElhaghiyehSaderehDetailPage,
      needAuth: true,
      parameters: ['gharardadBimehId'],
    },
  ],
];

export default MasooliatMadaniRoutes;
